export const TERMS_OF_USE = "Acepto los Términos y condiciones del servicio y contrato del plan, y políticas de tratamiento de datos."
export const TERMS_OF_DEBITS = "Acepto la Autorización de débitos automáticos, Contrato de permanencia y Declaración de ingresos."

export const PAYMENT_LINK_UUID_NOT_FOUND = {
  message: "¡Ha ocurrido un error!",
  description: "El link de pago no es valido"
}

export const PAYMENT_LINK_EXPIRED = {
  message: "El link de pago<br> ha caducado",
  description: "Vuelve a solicitarlo"
}
